import { render, staticRenderFns } from "./CraftModal.vue?vue&type=template&id=b77b8a3a&"
import script from "./CraftModal.vue?vue&type=script&lang=ts&"
export * from "./CraftModal.vue?vue&type=script&lang=ts&"
import style0 from "./CraftModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports